import en from "./en.json";
import ru from "./ru.json";
import kz from "./kz.json";
import enUs from "antd/lib/locale/en_US";
import ruRu from "antd/lib/locale/ru_RU";

export const antdLocaleMapping = {
  en: enUs,
  ru: ruRu,
  kz: ruRu,
};

export const messagesMapping = {
  en: en,
  ru: ru,
  kz: kz,
};
